<template>  
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>Solicitação de Estorno</span>
                    </li>
                </ul>
            </div>                    
            <div class="main-content-area">
                <div class="form-item">                    
                    <div class="row">
                        <div class="col-xs-12">
                            <h2 class="box-title">Solicitar Estorno</h2> 
                        </div>
                    </div>                     
                    <div class="docs-estorno">
                        <form @submit.prevent="frmEstorno" v-on:keyup.enter="EnviarEstorno()">
                            <div class="row">
                                <div class="col-md-0">
                                        <FormHelper :inputVar="frmEstorno.codSolicitante"
                                                    :form="frmEstorno"
                                                    label="Código do Solicitante"                                                                                                       
                                                    validationType="number"
                                                    type="hidden"></FormHelper>
                                </div>                                                                                         
                                <div class="col-md-3">
                                        <FormHelper :inputVar="frmEstorno.emailSolicitante"
                                                    :form="frmEstorno"                                                   
                                                    label="E-mail do Solicitante"                                                   
                                                    validationType="email"></FormHelper>
                                </div>
                            </div>                            
                            <div class="row">
                                <div class="col-md-8">
                                    <form name="frm-cadasfrmEstornotro-venda-direta" @submit.prevent="formTipoPessoa">
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="1"
                                                        type="radio"
                                                        id="juridica"
                                                        checked
                                                        v-on:change="limparDadosEstorno($event)"
                                                        v-model="formRegister.tipoPessoa"/>
                                                    <span>Pessoa Jurídica</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">       
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="0"
                                                        type="radio"
                                                        id="fisica"
                                                        checked
                                                        v-on:change="limparDadosEstorno($event)"
                                                        v-model="formRegister.tipoPessoa"/>
                                                    <span>Pessoa Física</span>
                                                </label>
                                            </div>
                                        </div>                                    
                                    </form>     
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-0">
                                        <FormHelper :inputVar="frmEstorno.codCliEstorno"
                                                    :form="frmEstorno"
                                                    label="Código do Cliente"                                               
                                                    type="hidden"
                                                    validationType="number"></FormHelper>
                                    </div>                                     
                                    <div class="col-md-3">
                                        <div v-show="formRegister.tipoPessoa == 1">
                                            <FormHelper :inputVar="frmEstorno.CNPJCliEstorno"
                                                        :form="frmEstorno"
                                                        id="CNPJCliEstorno"
                                                        label="CNPJ do Cliente"
                                                        mask="##.###.###/####-##"
                                                        validationType="cnpj"                                       
                                                        :disabled="frmEstorno.loadingCpfCNPJCliEstorno || disabledForm"></FormHelper>
                                        </div> 
                                        <div v-show="formRegister.tipoPessoa == 0">
                                            <FormHelper :inputVar="frmEstorno.CPFCliEstorno"
                                                        :form="frmEstorno"
                                                        id="CPFCliEstorno"
                                                        label="CPF do Cliente"
                                                        :mask="['###.###.###-##']"
                                                        placeholder="000.000.000-00"
                                                        validationType="cpf"                                       
                                                        :disabled="frmEstorno.loadingCpfCNPJCliEstorno || disabledForm"
                                                        ></FormHelper>
                                        </div>                                        
                                    </div>
                                    <div class="col-md-4">
                                        <FormHelper :inputVar="frmEstorno.nomeCliente"
                                                    :form="frmEstorno"
                                                    label="Nome do Cliente"
                                                    validationType="quotes"
                                                    :disabled="true"></FormHelper>
                                    </div>  
                                </div>                                                       
                            </div>                          
                            <div class="row">                                                              
                                <div class="col-md-6">
                                    <h2 class="box-title">Detalhes do Estorno</h2>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-12"> 
                                    <div class="col-md-3">
                                        <FormHelper :inputVar="frmEstorno.banco"
                                            :form="frmEstorno"                                      
                                            type="select"
                                            required="true"
                                            label="Banco"
                                            :options="lstbancos"                                                                                             
                                            placeholder="Selecione o Banco"></FormHelper>                                     
                                    </div>  
                                    <div class="col-md-2">
                                        <FormHelper :inputVar="frmEstorno.agencia"
                                                        :form="frmEstorno"
                                                        label="Código da Agência"                                                        
                                                        :type="number"
                                                        v-mask="['###############']"></FormHelper>
                                    </div>
                                    <div class="col-md-2">
                                        <FormHelper :inputVar="frmEstorno.dvAgencia"
                                                        :form="frmEstorno"
                                                        label="DV Agência"
                                                        :type="number"
                                                        :mask="['#']"></FormHelper>
                                    </div>
                                    <div class="col-md-2">
                                        <FormHelper :inputVar="frmEstorno.conta"
                                                        :form="frmEstorno"                                                       
                                                        label="Conta"
                                                        :type="number"
                                                        :mask="['####################']"></FormHelper>
                                    </div>
                                  
                                    <div class="col-md-2">
                                        <FormHelper :inputVar="frmEstorno.dvConta"
                                                        :form="frmEstorno"
                                                        label="DV Conta"
                                                        :type="number"
                                                        :mask="['#']"></FormHelper>
                                    </div>
                                    <div class="col-md-1 col-only-button">
                                       <a
                                        v-on:mouseover="mouseover"
                                        v-on:mouseleave="mouseleave">
                                            <img width="30" height="30"  src="/assets/images/Info.jpg">
                                        </a>
                                    </div> 
                                </div>   
                                <div class="col-md-12" v-show="message == true"> 
                                    <div class="col-md-9">  
                                    </div>
                                    <div class="col-md-3">
                                        <h7 class="box-title">
                                            Bancos que utilizam duas posições para o DV do Número da Conta Corrente, preencher este campo com a 1ª posição deste dígito. <br /> 
                                            Exemplo: Número C/C = 45981-36 <br/>
                                            Neste caso DV da Conta = 3
                                        </h7>
                                    </div>
                                </div>                           
                            </div> 
                            <div class="row">
                                <div class="col-md-12">                                                                 
                                    <div class="col-md-3">
                                        <FormHelper :inputVar="frmEstorno.valorEstorno"
                                                    :form="frmEstorno"
                                                    type="money"
                                                    label="Valor Estorno" 
                                                    :min="0.01"
                                                    :max="100000000"
                                                    validationType="rangeValue"></FormHelper>
                                    </div>  
                                    <div class="col-md-4"> 
                                        <FormHelperBlob :inputVar="frmEstorno.documentoEstorno"
                                                        :form="frmEstorno"
                                                        label="Autorização de Estorno Assinada"                                                   
                                                        type="file"                                                    
                                                        :fileTypes="['pdf','jpg']">                                                    
                                        </FormHelperBlob>
                                    </div>                                                          
                                    <div class="col-md-5">
                                        <FormHelper :inputVar="frmEstorno.descricao"
                                                    :form="frmEstorno"
                                                    label="Motivo"
                                                    type="textarea"
                                                    placeholder="Motivo"></FormHelper>
                                    </div> 
                                </div>                                
                            </div>  
                        </form>
                    </div>
                </div>
                <div v-if="frmEstorno.attemptSubmit && formErrors > 0" class="row">
                    <div class="col-md-12">
                        <div class="form-errors alert alert-danger" role="alert">
                            <i class="fa fa-warning"></i>
                            Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <button aria-label="Salvar" class="btn btn-primary" 
                        v-on:click="EnviarEstorno()" :disabled="(formErrors > 0 
                        && frmEstorno.attemptSubmit) || loadingRegister">
                            Salvar
                        </button>                            
                    </div>                         
                    <div v-if="loadingRegister" class="col-md-5">
                        <Loader />
                    </div>                           
                </div>            
            </div>
        </div>
    </main>
</template>
<script>
    import FormHelper from "../../components/partials/FormHelper.vue"; 
    import FormHelperBlob from "../../components/partials/FormHelperBlob.vue";         
    import axios from 'axios';
    
    export default {
        name: "Estorno",
        data() {
            return {
                message: false,
                HasNoData: true,  
                invalidCnpj: true,
                loadingRegister: false,
                disabledForm: false,
                file: null,

                formRegister: {
                    tipoPessoa: 1                    
                },

                frmEstorno: {
                    attemptSubmit: false,

                    //* Dados Solicitante */
                    codSolicitante: new this.formInput(false),                    
                    emailSolicitante: new this.formInput(),

                    //* Dados Cliente */                    
                    codCliEstorno: new this.formInput(false),
                    nomeCliente: new this.formInput(false),
                    CPFCliEstorno: new this.formInput(),
                    CNPJCliEstorno: new this.formInput(), 
                    loadingCpfCNPJCliEstorno: false,

                    //**Dados Estorno */
                    banco: new this.formInput(false),
                    agencia: new this.formInput(),
                    dvAgencia: new this.formInput(),
                    conta: new this.formInput(),
                    dvConta: new this.formInput(),
                    valorEstorno: new this.formInput(),              
                    descricao: new this.formInput(),    
                    
                    //**Documentação */
                    documentoEstorno: new this.formInput(true),

                    /* Pesssoa Juridica */
                    cnpj: new this.formInput(false),                    
                    cnpjInvalid: false, 
                    loadingCnpj: false                    
                },

                lstbancos: [],
            }
        },
        components: {
            FormHelper,
            FormHelperBlob
        },
        mounted(){
            let bancos = {};
            localStorage.currentStep = 0;
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(
                        () =>
                        (location.href =
                            `${self.$SiteUrl}/login?redirectTo=` + location.href)
                    );
                },
            });

            $.ajax({
                url: this.$apiUrlAPI + "Financeiro/ConsultarBancos",
                dataType: 'json',                
                type: 'GET',
                success: (data) => {
                    data.forEach((element) => {
                        bancos = {};
                        bancos.value = element.bcoCodigo,
                        bancos.label = element.bcoDescricao;
                        self.lstbancos.push(bancos);
                    })
                }
            });

            // self.ValidarParametros('HABILITAR_SOLICITACAO_ESTORNO_SITE');               
        },
        computed: {            
            formErrors: function () {                
                //Retorna os campos que estão com erro de validação
                let errors = Object.keys(this.frmEstorno).filter((key) => this.frmEstorno[key].validation && !this.frmEstorno[key].validation.status)
                
                //Retira 1 validação porque exite apenas CPF ou CNPJ para o cliente.
                return (errors.length - 1);             
            }
        },
        watch:{
            "frmEstorno.CNPJCliEstorno.value": async function (val) {
                if (val.length == 18) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                           
                        this.frmEstorno.nomeCliente.value = cliente.CliRazaosocial; 
                        this.frmEstorno.codCliEstorno.value = cliente.CliCodigo;                      
                    }
                    else
                    {
                        this.frmEstorno.nomeCliente.value = '';
                        this.frmEstorno.codCliEstorno.value = '';
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    }  
                }
            }, 
            "frmEstorno.CPFCliEstorno.value": async function (val) {
                if (val.length == 14) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                            
                        this.frmEstorno.nomeCliente.value = cliente.CliRazaosocial;  
                        this.frmEstorno.codCliEstorno.value = cliente.CliCodigo;                     
                    }
                    else
                    {
                        this.frmEstorno.nomeCliente.value = '';
                        this.frmEstorno.codCliEstorno.value = '';   
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    } 
                }
            }          
        },   
        methods: {            
            mouseover: function(){
                this.message = true;
            },    
            mouseleave: function(){
                this.message = false;
            },
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },

            EnviarEstorno: async function(){ 
                this.frmEstorno.attemptSubmit = true;               

                if (this.formErrors > 0)
                    return null;

                var dados = new FormData(); 
                dados.append('CliCodigo', JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente.CliCodigo); 
                dados.append('CliCodigoEstorno', this.frmEstorno.codCliEstorno.value);
                dados.append('EstEmail', this.frmEstorno.emailSolicitante.value);
                dados.append('EstValor', this.frmEstorno.valorEstorno.value.toString().replace('.', ','));                
                dados.append('BcoCodigo', this.frmEstorno.banco.value.value);
                dados.append('EstAgCodigo', this.frmEstorno.agencia.value);
                dados.append('EstAgDv', this.frmEstorno.dvAgencia.value)
                dados.append('EstNumConta', this.frmEstorno.conta.value);
                dados.append('EstDvconta', this.frmEstorno.dvConta.value);
                dados.append('EstDescricao', this.frmEstorno.descricao.value);
                dados.append('EstDocumento', this.frmEstorno.documentoEstorno.value);

                if (this.formRegister.tipoPessoa == 1)
                    dados.append('CliCiccgc', this.frmEstorno.CNPJCliEstorno.value.toString().replace(/\./g, '').replace('-', '').replace('/',''));
                else
                    dados.append('CliCiccgc', this.frmEstorno.CPFCliEstorno.value.toString().replace(/\./g, '').replace('-', ''));
            
                return axios({
                    method: "POST",
                    url: this.$apiUrlAPI + "Estorno/GerarEstorno",
                    headers: {"Content-Type": "multipart/form-data"},                    
                    data: dados                    
                }).then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.registroGerado > 0 ) { 
                            swal({
                                title: "Solicitação Enviada",
                                text: "Foi gerada a solicitação número: " + response.data.registroGerado,
                                icon: "success"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                                                                                                                        
                        }else{
                            swal({
                                title: 'Erro ao solicitar estorno!',
                                text: response.data.descricaoErro,
                                icon: 'warning'
                            })
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao solicitar estorno!',
                                text: 'Não foi possível enviar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });
            },            

            limparDadosEstorno: function(event){
                this.frmEstorno.CPFCliEstorno.value = '';
                this.frmEstorno.CNPJCliEstorno.value = '';
                this.frmEstorno.nomeCliente.value = '';
                this.frmEstorno.codCliEstorno.value = ''; 
                //this.frmEstorno.loadingCnpj = true;             
            },

            async ConsultarCliente (cnpj) { 
                var cliente = null;
                await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/getload/cli",
                    headers: {"Content-Type": "application/json"},                    
                    data: {cli_ciccgc: cnpj}                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.CliCodigo > 0) {  
                            console.log(response.data);
                            cliente = response.data;                                                                  
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
                return cliente              
            }, 
            
            async ConsultarBancos() {
                await axios({
                    method: "GET",
                    url: this.$apiUrl + "Financeiro/ConsultarClientePedido",
                    headers: {"Content-Type": "application/json"}, 
                    params: {
                        codigoPedido: pedido,
                        dvCodigoPedido: dv
                    }                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        console.log(response.data);
                        clientePedido = response.data;
                    }else{
                        return swal({
                            title: 'Pedido não encontrado!',                           
                            icon: 'warning'
                        });
                    }
                }).catch((error) =>{ 
                    return swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar o pedido. Erro: ' + error,
                                icon: 'warning'
                    });
                });
                
                return clientePedido;
            },            
            
            async ValidarParametros(parNome){                 
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Parametros/Consultar",
                    headers: {"Content-Type": "application/json"},                    
                    params: {'nomeParametro': parNome}
                }).then(response => {  
                    if(response.status == 200){ 
                        if(response.data.parValor == "N")
                        {                                           
                            swal({
                                title: "Erro ao Carregar Página",
                                text: "Esta página não está habilitada para uso. Por favor, consulte o administrador do sistema!",
                                icon: "warning"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                         
                        }
                    }                          
                }).catch(function (error) {
                    console.log(error);                
                });
            }, 
        }
    };
</script>